/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { ReferenceNumberRequest } from '../../models/reference-number-request';
import { Token64LengthXorEmptyType } from '../../models/token-64-length-xor-empty-type';

export interface PatchExternalReferenceNumberTour$Params {

/**
 * The tour key
 */
  tourKey: KeyType;
  accessToken?: Token64LengthXorEmptyType;
      body: ReferenceNumberRequest
}

export function patchExternalReferenceNumberTour(http: HttpClient, rootUrl: string, params: PatchExternalReferenceNumberTour$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, patchExternalReferenceNumberTour.PATH, 'patch');
  if (params) {
    rb.path('tourKey', params.tourKey, {});
    rb.query('accessToken', params.accessToken, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

patchExternalReferenceNumberTour.PATH = '/external/tours/{tourKey}/reference-number';
